import TrackingJS from "@vp/tracking"
import React from "react"
import TRACKING_CONFIGURATION from "./trackingConfiguration"

export default class Analytics extends React.Component {
  render() {
    return <></>
  }

  async componentDidMount() {
    TrackingJS.initWithData(this.props.trackingConfig)
    const tracking = TrackingJS.getTracking()

    this.sendPageTracking(tracking)
  }

  sendPageTracking(tracking) {
    tracking.page({
      pageName: `${this.props.pageName}`,
      pageSection: `${this.props.pageSection}`,
      pageStage: TRACKING_CONFIGURATION.PAGE_STAGE,
      genTrack: "Gatsby",
      languageLocale: `${this.props.locale}`,
    })
  }
}
